import { render } from "./marketplace_activate.html?vue&type=template&id=48a90528&scoped=true&external"
import script from "./marketplace_activate.js?vue&type=script&lang=js&external"
export * from "./marketplace_activate.js?vue&type=script&lang=js&external"

import "./MicrosoftMarketplaceActivate.vue?vue&type=style&index=0&id=48a90528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a90528"]])

export default __exports__